import React from "react";
import { normalizeTwoWords, findRel, OptimizeImage } from "../../../shared/utils/stringUtilities";
import Button from '../../atoms/button/button';
import "./cardDocument.scss";
import axios from 'axios';
import fileDownload from 'js-file-download';
import { useStaticQuery, graphql } from "gatsby";

const CardDocument = (props: ReviewInterface) => {

  const icons = useStaticQuery(graphql`
    query SOCIAL_NETWORK_ICONS {
      contentfulPlantillaContenido(titulo: {eq: "iconos redes sociales compatir"}) {
        titulo
        imagenPrincipal {
          file {
            fileName
            url
          }
        }
      }
    }
  `);

  const { review, gtmClass } = props;

  const downloadFile = async (url: string, filename: string) => {
    axios.get(url, {
       responseType: 'blob',
    })
    .then((res) => {
      fileDownload(res.data, filename)
    })
  }

  return (
    <div className={`a-card-doc gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.titulo)}`}>
      <a 
        href={review.redireccionBoton}
        className={`a-card-doc__content gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.titulo)}`}
        rel={findRel(review.redireccionBoton)}
      >
        <div className={`a-card-doc__content__img gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.titulo)}`}>
          <img
            loading="lazy"
            className={`gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.titulo)}`}
            src={OptimizeImage(review.imagenPrincipal[0].file.url, review.imagenPrincipal[0].file.contentType, 200)}
            alt={
              review.imagenPrincipal
                ? review.imagenPrincipal[0].title 
                  ? review.imagenPrincipal[0].title
                  : review.titulo
                : "Imagen portada"
            }
          />
        </div>
        <h3 className={`a-card-doc__content__title hide-on-mobile gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.titulo)}`}>
          {review.titulo}
        </h3>
        <h3 className={`a-card-doc__content__title show-on-mobile gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.titulo)}`}>
          {review.titulo}
        </h3>

        <div className="a-card-doc__content__menu">
          <div className="a-card-doc__content__menu__button">
            <Button
              id='buttonDescription'
              type='link'
              href={review.redireccionBoton ? review.redireccionBoton : '#'}
              classname={'tertiary '}
              text={review.tituloBoton}
              isDisabled={false}
              download={review.documentos ? true : false}
              onClickAction={review.documentos ? ( () => downloadFile(review.documentos.file.url, `${review.documentos.title}.${review.documentos.description}`) ) : console.log}
            />
          </div>
          <div className="a-card-doc__content__menu__share">
            {!review.documentos ?
              <a
                href={`https://twitter.com/intent/tweet?text=${review.redireccionBoton}`}
                target="_blank"
                rel="noreferrer">
                <img src={(icons && icons.contentfulPlantillaContenido && icons.contentfulPlantillaContenido.imagenPrincipal) && icons.contentfulPlantillaContenido.imagenPrincipal[0].file.url} alt="twitter"/>
              </a>
            : null}
            {!review.documentos ? 
              <a 
                href={`https://www.facebook.com/sharer/sharer.php?u=${review.redireccionBoton}`}
                target="_blank"
                rel="noreferrer">
                <img src={(icons && icons.contentfulPlantillaContenido && icons.contentfulPlantillaContenido.imagenPrincipal) && icons.contentfulPlantillaContenido.imagenPrincipal[1].file.url} alt="facebook"/>
              </a>
            : null}
            {!review.documentos ? 
              <a 
                href={`https://www.linkedin.com/cws/share?url=${review.redireccionBoton}`}
                target="_blank"
                rel="noreferrer">
                <img src={(icons && icons.contentfulPlantillaContenido && icons.contentfulPlantillaContenido.imagenPrincipal) && icons.contentfulPlantillaContenido.imagenPrincipal[2].file.url} alt="linkedIn"/>
              </a>
            : null}
            <a
              href={`mailto:?subject=Comfama&body=Este documento puede ser de tu interés: ${review.documentos ? `${review.documentos.file.url}` : review.redireccionBoton}`}
              target="_blank"
              rel="noreferrer">
              <img src={(icons && icons.contentfulPlantillaContenido && icons.contentfulPlantillaContenido.imagenPrincipal) && icons.contentfulPlantillaContenido.imagenPrincipal[3].file.url} alt="mail"/>
            </a>
          </div>
        </div>
      </a>
    </div>
  );
};

interface ReviewInterface {
  review: {
    redireccionBoton: string;
    imagenPrincipal: any;
    titulo: string;
    tituloBoton: string;
    documentos: any;
  };
  gtmClass: string;
}

export default CardDocument;
